import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ReportsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
ReportsViewTopBar.displayName = "ReportsViewTopBar"
